import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Politique de facturation globale (Paramètres → FNE › Régime d'imposition).
 * `vatBlocked` = le régime interdit de collecter la TVA (TEE / RME / TCE) : tout
 * interrupteur TVA doit être grisé et forcé à non.
 */
export function useBillingPolicy(enabled = true) {
  const [billingPolicy, setBillingPolicy] = useState(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    axios.get(`${API}/fne/billing-policy`)
      .then(({ data }) => { if (!cancelled) setBillingPolicy(data); })
      .catch(() => { if (!cancelled) setBillingPolicy(null); });
    return () => { cancelled = true; };
  }, [enabled]);

  return billingPolicy;
}

export default useBillingPolicy;
